module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_6_TECNOLÓGICO.48655d6d.jpg";